// DialogInvoiceTemplate Component

import React, { Component } from 'react'
import PropTypes from 'prop-types'

import Dialog from '../../../common/layout/dialog/dialog.jsx'
import IconButton from '../../../common/common/icon_button/icon_button.jsx'
import IntlMessage from '../../../common/common/intl/intl_message.jsx'
import ConfirmDelete from '../../../common/common/confirm_delete/confirm_delete.jsx'
import Input from '../../../common/form/input/input.jsx'
import Select from '../../../common/form/select/select.jsx'
import FormDatePicker from '../../../common/form/form_datepicker/form_datepicker.jsx'
import FormAutoComplete from '../../../common/form/auto_complete/auto_complete.jsx'
import Tab from '../../../common/layout/tab/tab.jsx'
import TabPanel from '../../../common/layout/tab_panel/tab_panel.jsx'
import FabButtonManager from '../../../lib/fabbuttonmanager.jsx'
import Checkbox from '../../../common/form/checkbox/checkbox.jsx'
import util from '../../../lib/util.jsx'
import InvoiceUtil from '../../../lib/invoiceutil.js'

class DialogInvoiceTemplate extends Component {
  constructor (props) {
    super(props)

    this.state = this._getDefaultState()

    this.data = {
      invoiceTemplateId: null,
      contacts: [],
      projects: [],
      bHideDrop: false,
      bEdit: false,
      interval: 'weekly',
      type: 'based-on-invoices'
    }

    this._bContactSearchPending = false
    this._contactSearchKeyword = ''
    this._references = {
      startDate: React.createRef(),
      inputContact: React.createRef(),
      firstPeriodDate: React.createRef(),
      endDate: React.createRef(),
      selectProject: React.createRef(),
      inputNoInvoices: React.createRef(),
      refDeleteConfirm: React.createRef()
    }
  }

  static get propTypes () {
    return {
      onSubmit: PropTypes.func,
      onDelete: PropTypes.func,
      contactSearch: PropTypes.func,
      getProjects: PropTypes.func,
      onClose: PropTypes.func,
      isQuickbookConnected: PropTypes.bool
    }
  }

  static get defaultProps () {
    return {
      onSubmit: null,
      onDelete: null,
      contactSearch: null,
      getProjects: null,
      onClose: null,
      isQuickbookConnected: false
    }
  }

  show (invoiceTemplate, bStartDateErr) {
    const showStartDateErr = !!bStartDateErr
    if (this._references.startDate.current && showStartDateErr) {
      this._references.startDate.current.validate()
    }

    const stateObj = {
      active: true,
      dataDate: new Date(),
      autoMail: !!this.props.isQuickbookConnected,
      showError: showStartDateErr
    }

    if (invoiceTemplate !== undefined && invoiceTemplate) {
      this.data.invoiceTemplateId = invoiceTemplate.id
      this.data.bEdit = true
      this.data.invoiceTemplate = invoiceTemplate
      this.data.type = invoiceTemplate.type
      this.data.interval = invoiceTemplate.interval

      stateObj.projectId = invoiceTemplate.projectId

      stateObj.contactId = invoiceTemplate.contactId
      stateObj.noInvoices = invoiceTemplate.noInvoices
      stateObj.firstPeriodDate = invoiceTemplate.firstPeriodDate
        ? new Date(invoiceTemplate.firstPeriodDate)
        : ''
      stateObj.startDate = invoiceTemplate.startDate
        ? new Date(invoiceTemplate.startDate)
        : ''
      stateObj.endDate = invoiceTemplate.endDate
        ? new Date(invoiceTemplate.endDate)
        : ''
      stateObj.autoMail = invoiceTemplate.autoMail
      stateObj.displayContactName = invoiceTemplate.contact
        ? invoiceTemplate.contact.company
        : ''
    }

    if (this.data.bEdit) {
      this.props.getProjects(invoiceTemplate.contactId, (projects) => {
        this.data.projects = projects

        this.data.bHideDrop = false
        if (this.data.projects.length === 0) {
          this.data.bHideDrop = true
        }

        this.setState(stateObj)
      })
    } else {
      this.setState(stateObj)
    }

    FabButtonManager.setVisible(false)
  }

  hide () {
    FabButtonManager.setVisible(true)
    this.setState(this._getDefaultState())

    this.data = {
      invoiceTemplateId: null,
      contacts: [],
      projects: [],
      bHideDrop: false,
      bEdit: false,
      interval: 'weekly',
      type: 'based-on-invoices'
    }
    if (this._references.inputContact.current) {
      this._references.inputContact.current.clearError()
    }
    if (this._references.firstPeriodDate.current) {
      this._references.firstPeriodDate.current.showError(false)
    }

    if (this._references.startDate.current) {
      this._references.startDate.current.showError(false)
    }

    if (this._references.endDate.current) {
      this._references.endDate.current.showError(false)
    }

    if (this._references.selectProject.current) {
      this._references.selectProject.current.clearError()
    }
  }

  isActive () {
    return this.state.active
  }

  componentDidMount () {
    document.body.addEventListener('keydown', this._onKeyDown)
  }

  componentWillUnmount () {
    document.body.removeEventListener('keydown', this._onKeyDown)
  }

  _onKeyDown = (ev) => {
    if (this.state.active && ev.keyCode === 13) {
      this._onFormSubmit(ev)
    }
  };

  render () {
    const classHeader = !this.state.showError
      ? 'dialogform-header'
      : 'dialogform-header showerr'
    const disabled = this.data.bEdit
    const title = this.data.bEdit
      ? 'invoicetemplate.form.invoiceTemplateEditTitle'
      : 'invoicetemplate.form.invoiceTemplateTitle'
    const { isQuickbookConnected } = this.props

    return (
      <Dialog
        active={this.state.active}
        onClose={this.hide.bind(this)}
        type='medium'
      >
        <div className='dialog-form dialog-invoicetemplate'>
          <div className={classHeader}>
            {!this.state.showError ? (
              <div className='title'>
                <IntlMessage ident={title} />
              </div>
            ) : (
              <div className='info'>
                <IntlMessage ident='invoice.form.addErrorInfo' />
              </div>
            )}
            <IconButton
              icon='wizard-close'
              className='modal wizard-close dialog-form-close'
              canHover={false}
              onClick={this._onClickClose.bind(this)}
            />
          </div>
          <div className='dialogform-content'>
            <form className='form' method='post' noValidate action='#'>
              <div className='form-layout'>
                <div className='layoutcol'>
                  <div className='formsection'>
                    <div className={!disabled ? 'formrow' : 'formrow disabled'}>
                      <div className='formcol'>
                        <FormAutoComplete
                          label='invoicetemplate.form.labelClient'
                          ref={this._references.inputContact}
                          validations={['required']}
                          name='contactId'
                          value={this.state.contactId}
                          displayValue={this.state.displayContactName}
                          options={this.data.contacts}
                          onChange={this._handleSearchContact.bind(this)}
                          onSelect={this._handleContactSelect.bind(
                            this,
                            'contactId'
                          )}
                          hideAdd
                          hasAutoSelect
                        />
                      </div>
                    </div>
                    {!this.data.bHideDrop ? (
                      <div
                        className={!disabled ? 'formrow' : 'formrow disabled'}
                      >
                        <div className='formcol'>
                          <Select
                            options={this.data.projects}
                            name='project'
                            className='form-dropdown'
                            ref={this._references.selectProject}
                            label='invoicetemplate.form.labelProject'
                            value={this.state.projectId}
                            onChange={this._onChangeInput.bind(
                              this,
                              'projectId'
                            )}
                          />
                        </div>
                      </div>
                    ) : (
                      <div
                        className={!disabled ? 'formrow' : 'formrow disabled'}
                      >
                        <div className='formcol'>
                          <span className='norecrds'>
                            <IntlMessage ident='invoicetemplate.form.noProjectsFoundForClient' />
                          </span>
                        </div>
                      </div>
                    )}
                    <div className='formrow'>
                      <div className='formcol'>
                        <FormDatePicker
                          label='invoicetemplate.form.firstPeriodDate'
                          placeholder='invoicetemplate.form.firstPeriodDate'
                          value={this.state.firstPeriodDate}
                          name='firstPeriodDate'
                          onChange={this._onChangeDate.bind(
                            this,
                            'firstPeriodDate',
                            'firstPeriodDate',
                            false
                          )}
                          ref={this._references.firstPeriodDate}
                        />
                      </div>
                    </div>
                    <div className='formrow'>
                      <Tab
                        showFullBorder
                        onChange={this._onChangeType.bind(this)}
                      >
                        <TabPanel
                          title='invoicetemplate.form.weekly'
                          active={
                            this.data.interval === 'weekly'
                          }
                        />
                        <TabPanel
                          title='invoicetemplate.form.monthly'
                          active={
                            this.data.interval === 'monthly'
                          }
                        />
                        <TabPanel
                          title='invoicetemplate.form.quaterly'
                          active={
                            this.data.interval === 'quaterly'
                          }
                        />
                        <TabPanel
                          title='invoicetemplate.form.yearly'
                          active={
                            this.data.interval === 'yearly'
                          }
                        />
                      </Tab>
                    </div>
                    <div className='formrow'>
                      <div className='formcol'>
                        <Input
                          type='text'
                          name='noInvoices'
                          label='invoicetemplate.form.noInvoices'
                          size={10}
                          maxLength={100}
                          styleDotted
                          ref={this._references.inputNoInvoices}
                          validations={['required', 'positive']}
                          value={this.state.noInvoices}
                          onChange={this._onChangeInput.bind(
                            this,
                            'noInvoices'
                          )}
                        />
                      </div>
                    </div>
                    <div className='formrow'>
                      <div className='formcol'>
                        <FormDatePicker
                          label='invoicetemplate.form.startDate'
                          placeholder='invoicetemplate.form.startDate'
                          value={this.state.startDate}
                          name='startDate'
                          ref={this._references.startDate}
                          onChange={this._onChangeDate.bind(
                            this,
                            'startDate',
                            'startDate',
                            true
                          )}
                        />
                      </div>
                    </div>
                    <div className='formrow disabled'>
                      <div className='formcol'>
                        <FormDatePicker
                          label='invoicetemplate.form.endDate'
                          placeholder='invoicetemplate.form.endDate'
                          value={this.state.endDate}
                          name='endDate'
                          ref={this._references.endDate}
                        />
                      </div>
                    </div>
                    <div className='formrow'>
                      <Checkbox
                        label={
                          isQuickbookConnected
                            ? 'invoicetemplate.form.autoMailQuickbook'
                            : 'invoicetemplate.form.autoMail'
                        }
                        checked={this.state.autoMail}
                        icon='login'
                        className='invoicetemplate'
                        onChange={this._onCheckEmail.bind(this)}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </form>
            {this.data.bEdit && (
              <IconButton
                type='secondary'
                size='big'
                icon='action-delete'
                title='time.form.tipDelete'
                className='actdelete'
                canHover={false}
                onClick={this._onDelete.bind(this)}
              />
            )}
            <IconButton
              type='primary'
              size='big'
              icon='common-success-tick'
              canHover={false}
              title='expense.form.addBudgetExpense'
              onClick={this._onFormSubmit.bind(this)}
            />
            <ConfirmDelete
              ref={this._references.refDeleteConfirm}
              title='invoicetemplate.view.confirmDelete'
              onClickOk={this._onDeleteConfirm.bind(this)}
            />
          </div>
        </div>
      </Dialog>
    )
  }

  /* Private functions */
  _getDefaultState () {
    return {
      active: false,
      contactId: '',
      projectId: null,
      noInvoices: '',
      firstPeriodDate: null,
      startDate: null,
      endDate: null,
      autoMail: false,
      contactName: '',
      displayContactName: '',
      showError: false,
      dataDate: null
    }
  }

  _validateDates (date, refName) {
    if (this._references[`${refName}`].current) {
      this._references[`${refName}`].current.showError(
        this._isDateIsPast(date)
      )
    }
  }

  _validateDatesOnSubmit (date, refName) {
    const bDatePast = this._isDateIsPast(date)
    if (this._references[`${refName}`].current) {
      this._references[`${refName}`].current.showError(bDatePast)
    }

    return bDatePast
  }

  /* Event Handlers */
  _onFormSubmit (ev) {
    ev.preventDefault()

    let noErrors = 0
    if (
      this._references.inputContact.current &&
      !this._references.inputContact.current.validate()
    ) {
      noErrors++
    }

    if (
      (this._references.selectProject.current &&
      !this._references.selectProject.current.validate()) ||
      !this.state.projectId
    ) {
      noErrors++
    }

    if (
      this._references.inputNoInvoices.current &&
      !this._references.inputNoInvoices.current.validate()
    ) {
      noErrors++
    }

    if (
      this._references.startDate.current &&
      !this._references.startDate.current.validate()
    ) {
      noErrors++
    }

    if (
      this._references.firstPeriodDate.current &&
      !this._references.firstPeriodDate.current.validate()
    ) {
      noErrors++
    }

    const bStartDateValid = this._validateDatesOnSubmit(
      this.state.startDate,
      'startDate'
    )
    if (bStartDateValid) {
      noErrors++
    }

    if (noErrors === 0) {
      const templateObj = {
        contactId: this.state.contactId,
        projectId: this.state.projectId,
        noInvoices: this.state.noInvoices || 0,
        firstPeriodDate: this.state.firstPeriodDate
          ? new Date(this.state.firstPeriodDate)
          : null,
        startDate: this.state.startDate ? new Date(this.state.startDate) : null,
        endDate: this.state.endDate ? new Date(this.state.endDate) : null,
        autoMail: this.state.autoMail,
        type: this.data.type,
        interval: this.data.interval,
        budget: {
          phases: [
            {
              title: '',
              total: 0,
              percentage: 0,
              spentAmount: 0
            }
          ],
          total: 0,
          totalSpent: 0
        }
      }

      const templateId = this.data.invoiceTemplateId
        ? this.data.invoiceTemplateId
        : null

      this.props.onSubmit(templateObj, templateId)
    } else {
      this.setState({ showError: true, loading: { isSubmitting: false } })
    }
  }

  _onDelete (ev) {
    ev.preventDefault()
    if (this._references.refDeleteConfirm.current) {
      this._references.refDeleteConfirm.current.show()
    }
  }

  _onDeleteConfirm (ev) {
    ev.preventDefault()
    if (this.props.onDelete) {
      this.props.onDelete(this.data.invoiceTemplateId)
    }
  }

  _onClickClose (ev) {
    ev.preventDefault()
    this.hide()

    if (this.props.onClose) {
      this.props.onClose()
    }
  }

  _onChangeDate (name, refName, bValidate, value) {
    value = value || new Date()
    if (bValidate) {
      this._validateDates(value, refName)
    }

    let lastRecurringDate = null
    if (name === 'startDate' && this.state.noInvoices) {
      lastRecurringDate = InvoiceUtil.calculateRecurringInfo(
        this.data.interval,
        value,
        this.state.noInvoices
      )
    }

    this.setState({ [name]: value, endDate: lastRecurringDate })
  }

  _isDateIsPast (date) {
    const currDate = new Date()
    const dateTimeStamp = new Date(date).getTime()
    const currDateTimeStamp = new Date(currDate).getTime()

    if (util.isDateEqual(new Date(date), new Date(currDate))) {
      return false
    }

    if (dateTimeStamp < currDateTimeStamp) {
      return true
    }

    return false
  }

  _onChangeType (index) {
    let interval = ''
    let lastRecurringDate = null

    if (index === 0) {
      interval = 'weekly'
    } else if (index === 1) {
      interval = 'monthly'
    } else if (index === 2) {
      interval = 'quaterly'
    } else if (index === 3) {
      interval = 'yearly'
    }

    this.data.interval = interval
    const stateObj = { dataDate: new Date() }

    if (this.state.noInvoices && this.state.startDate) {
      lastRecurringDate = InvoiceUtil.calculateRecurringInfo(
        interval,
        this.state.startDate,
        this.state.noInvoices
      )

      stateObj.endDate = lastRecurringDate
    }

    this.setState(stateObj)
  }

  _onChangeInput (name, value) {
    let lastRecurringDate = null
    if (name === 'noInvoices' && this.state.startDate) {
      lastRecurringDate = InvoiceUtil.calculateRecurringInfo(
        this.data.interval,
        this.state.startDate,
        value
      )
    }

    this.setState({ [name]: value, endDate: lastRecurringDate })
  }

  _onCheckEmail () {
    this.setState({ autoMail: !this.state.autoMail })
  }

  _handleSearchContact (keyword) {
    if (keyword && this._references.inputContact.current) {
      this._references.inputContact.current.clearError()
    }

    this.setState({ displayContactName: keyword })
    this._processContactSearch(keyword)
  }

  _processContactSearch (keyword) {
    if (keyword.length < 1) return

    if (!this._bContactSearchPending) {
      this._bContactSearchPending = true
      if (this.props.contactSearch) {
        this.props.contactSearch(
          keyword,
          this._onSearchRecieved.bind(this, keyword)
        )
      }
    } else {
      this._contactSearchKeyword = keyword
    }
  }

  _onSearchRecieved (keyword, result) {
    this._bContactSearchPending = false

    this.data.contacts = result.filter(contact => contact.bArchived === false)
    const stateObj = {}
    if (result && result.length > 0) {
      stateObj.contactId = ''
      stateObj.contactName = keyword
    }

    this.setState(stateObj)

    if (this._contactSearchKeyword) {
      const keyword = this._contactSearchKeyword
      this._contactSearchKeyword = ''
      this._processContactSearch(keyword)
    }
  }

  _handleContactSelect (name, obj) {
    if (obj) {
      this.setState({ [name]: obj.value, displayContactName: obj.label })

      if (this.props.getProjects) {
        this.props.getProjects(obj.value, (obj) => {
          this.data.projects = obj

          this.data.bHideDrop = false
          if (this.data.projects.length === 0) {
            this.data.bHideDrop = true
          }

          this.setState({ dataDate: new Date() })
        })
      }
    } else {
      this.data.projects = []
      this.data.bHideDrop = false

      this.setState({ [name]: '' })
    }
  }
}

export default DialogInvoiceTemplate
